meedy.controller('meedy.homeRedirectController', ['$scope', '$state', '$mdToast', '$mdDialog', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel',
    function ($scope, $state, $mdToast, $mdDialog, objectHelper, applicationModel, userModel) {

        function setData() {
            //
        }

        function setPermissions() {
            //
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            //
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.HOME);
            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.HOME_PAGE');
        }

        function initialize() {
            applicationModel.viewReady = true;
            
            if(userModel.currentUser && userModel.currentUser.alabDiagnostician) {
				$state.go(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST);
            } else if(userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT) {
                $state.go(Constant.STATE.APP.MEEDY.CALENDAR.DAILY_PLAN);
            } else {
				$state.go(Constant.STATE.APP.MEEDY.CALENDAR.INDEX);
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
